const NODE_ENV = process.env.NODE_ENV
const APP_ENV = process.env.APP_ENV

export const isProduction = (): boolean => {
  return NODE_ENV === 'production' && APP_ENV === 'production'
}
